import {connect} from 'react-redux'
import {
  accountPageRequest,
  settingAccountRequest
} from 'actions/setting/account'
import styles from './style.css'
import AccountForm from './AccountForm'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import {browserHistory} from 'react-router'
import {push} from 'react-router-redux'

class Account extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(accountPageRequest())
      browserHistory.listenBefore((location) => {
        if (this.props.data.isDirtyForm && !this.props.nextAction) {
          // negate the change location, instead use sagas to handle the change location
          this.props.dispatch(askConfirmAction(push(location.pathname)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {user} = this.props.data.moka
    return (
      <div id='account-setting'>
        <div className='row'>
          <div className='col-md-6 col-lg-6 col-sm-12'>
            <div className={styles['mk-section-header']}>
              ACCOUNT
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6 col-lg-6 col-sm-12'>
            <AccountForm
              email={user.email}
              onSubmit={this._handleSubmit}
            />
          </div>
        </div>
        <ConfirmActionModal />
      </div>
    )
  }

  _handleSubmit = (account) => {
    let {user} = this.props.data.moka
    let {values} = this.props.data.form.accountForm
    account = {
      password_confirmation: values.old_password,
      user: {
        email: user.email,
        first_name: values.first_name || user.first_name,
        last_name: values.last_name || user.last_name,
        password: values.password,
        password_confirmation: values.password_confirmation,
        security_question: user.security_question || null,
        security_question_answer: user.security_question_answer || null,
        updated_at: user.updated_at
      }
    }
    this.props.dispatch(settingAccountRequest(account))
  }
}

function mapStateToProps (state) {
  return {
    data: {
      moka: state.moka,
      form: state.form,
      isDirtyForm: isDirty('accountForm')(state),
      subscriptionExpired: state.subscriptionExpired
    },
    nextAction: state.confirmAction.nextAction
  }
}

export default connect(mapStateToProps)(Account)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Account/Account.js